import { CALL_API } from "redux-api-middleware";
import { ho } from "apis/homeowner/ho";
import api from "apis/casePhotos";
import {
  REQUEST_CASEHEADER_RESULTS,
  RECEIVE_CASEHEADER_RESULTS,
  ERROR_CASEHEADER_RESULTS,
  REQUEST_APPRAISALQAREJECTIONS_RESULTS,
  RECEIVE_APPRAISALQAREJECTIONS_RESULTS,
  ERROR_APPRAISALQAREJECTIONS_RESULTS,
  REQUEST_APPRAISALQAREJECTION_UPDATE,
  RECEIVE_APPRAISALQAREJECTION_UPDATE,
  ERROR_APPRAISALQAREJECTIONS_UPDATE,
  REQUEST_FILES_RESULTS,
  RECEIVE_FILES_RESULTS,
  ERROR_FILES_RESULTS,
  REQUEST_HISTORY_RESULTS,
  RECEIVE_HISTORY_RESULTS,
  ERROR_HISTORY_RESULTS,
  REQUEST_PRIVATENOTES_RESULTS,
  RECEIVE_PRIVATENOTES_RESULTS,
  ERROR_PRIVATENOTES_RESULTS,
  REQUEST_PRIVATENOTES_UPDATE,
  RECEIVE_PRIVATENOTES_UPDATE,
  ERROR_PRIVATENOTES_UPDATE,
  REQUEST_CASEFORMS_RESULTS,
  RECEIVE_CASEFORMS_RESULTS,
  ERROR_CASEFORMS_RESULTS,
  REQUEST_WORKFLOWMETHOD_RESULTS,
  RECEIVE_WORKFLOWMETHOD_RESULTS,
  ERROR_WORKFLOWMETHOD_RESULTS,
  REQUEST_WORKFLOWSTATUS_RESULTS,
  RECEIVE_WORKFLOWSTATUS_RESULTS,
  ERROR_WORKFLOWSTATUS_RESULTS,
  UPDATE_WORKFLOW_MONITOR,
  REQUEST_SKETCH_RESULTS,
  RECEIVE_SKETCH_RESULTS,
  ERROR_SKETCH_RESULTS,
  SUCCESS_PNX_SAVE,
  ERROR_PNX_SAVE,
  FORM_STATUS_CHANGE,
  REQUEST_IMPORT_MISMO,
  RECEIVE_IMPORT_MISMO,
  ERROR_IMPORT_MISMO,
  REQUEST_VALIDATE_FORMS,
  RECEIVE_VALIDATE_FORMS,
  ERROR_VALIDATE_FORMS,
  VALIDATE_RESPONSE,
  BACKFILL_RCT,
  BACKFILL_RCT_SUCCESS,
  BACKFILL_RCT_ERROR,
  REQUEST_PROP_RECORD_RESULTS,
  RECEIVE_PROP_RECORD_RESULTS,
  ERROR_PROP_RECORD_RESULTS,
  REQUEST_CASE_ATTR,
  RECEIVE_CASE_ATTR,
  ERROR_CASE_ATTR,
  REQUEST_UPDATE_CASEHEADER,
  RECEIVE_UPDATE_CASEHEADER,
  ERROR_UPDATE_CASEHEADER,
  REQUEST_APPRAISAL_FORM_DATA,
  RECEIVE_APPRAISAL_FORM_DATA,
  ERROR_APPRAISAL_FORM_DATA,
  REQUEST_SAVE_1004P_FORM_DATA,
  RECEIVE_SAVE_1004P_FORM_DATA,
  ERROR_SAVE_1004P_FORM_DATA,
  REQUEST_PNX_FORM_EXPORT_DATA,
  RECEIVE_PNX_FORM_EXPORT_DATA,
  ERROR_PNX_FORM_EXPORT_DATA,
  REQUEST_SAVE_PNX_FORM_EXPORT_DATA,
  RECEIVE_SAVE_PNX_FORM_EXPORT_DATA,
  ERROR_SAVE_PNX_FORM_EXPORT_DATA,
  REQUEST_SUBMIT_TO_QA,
  RECEIVE_SUBMIT_TO_QA,
  ERROR_SUBMIT_TO_QA,
  REQUEST_CANCEL_CASE,
  RECEIVE_CANCEL_CASE,
  ERROR_CANCEL_CASE,
  REQUEST_ADD_ATTACHMENT,
  RECEIVE_ADD_ATTACHMENT,
  ERROR_ADD_ATTACHMENT,
  REQUEST_DELETE_ATTACHMENT,
  RECIEVE_DELETE_ATTACHMENT,
  ERROR_DELETE_ATTACHMENT,
  BEGIN_PHOTOS_SORT_ORDER,
  SET_PHOTOS_SORT_ORDER,
  REQUEST_SAVE_PHOTOS_SORT_ORDER,
  RECEIVE_SAVE_PHOTOS_SORT_ORDER,
  ERROR_SAVE_PHOTOS_SORT_ORDER,
  REQUEST_CASE_HEADER,
  RECEIVE_CASE_HEADER,
  ERROR_CASE_HEADER,
  SAVE_COMP_PHOTO_METADATA,
  REQUEST_PHOENIX_RCT_CALC,
  RECEIVE_PHOENIX_RCT_CALC,
  ERROR_PHOENIX_RCT_CALC,
} from "typeConstants";
import responseHandler from "responseHandler";
import { getValidationStatus } from "actions/validation";
import { HTTP_GET, HTTP_POST, HTTP_DELETE, HTTP_PUT, WebApiReduxRequest } from "tools/webservice";

function ValidateControlNumber(id, getState) {
  let controlNumber = 0;
  if (id && id !== undefined && id !== null && id !== 0) {
    controlNumber = id;
  } else {
    controlNumber = getState().caseForms.caseHeader.caseInfo.controlNumber;
    if (controlNumber == undefined || !controlNumber) return 0;
  }
  return controlNumber;
}

const getCaseForms = (text, callback = null) => {
  return dispatch =>
    dispatch({
      [CALL_API]: {
        endpoint: ho.caseForms(text),
        method: HTTP_GET,
        types: [
          REQUEST_CASEFORMS_RESULTS,
          {
            type: RECEIVE_CASEFORMS_RESULTS,
            payload: (action, state, res) =>
              res.json().then(data => {
                callback && callback(data);
                return data;
              })
          },
          {
            type: ERROR_CASEFORMS_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
};

const getCaseHeader = (id, callback = null) => {
  return (dispatch, getState) => {
    let controlNumber = ValidateControlNumber(id, getState);
    if (controlNumber === 0) return;
    dispatch({
      [CALL_API]: {
        endpoint: ho.header(controlNumber),
        method: HTTP_GET,
        types: [
          REQUEST_CASEHEADER_RESULTS,
          {
            type: RECEIVE_CASEHEADER_RESULTS,
            payload: (action, state, res) =>
              res.json().then(data => {
                callback && callback(data);
                return data;
              })
          },
          {
            type: ERROR_CASEHEADER_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getFiles = text => {
  return dispatch =>
    dispatch({
      [CALL_API]: {
        endpoint: ho.caseForm(text, "files"),
        method: HTTP_GET,
        types: [
          REQUEST_FILES_RESULTS,
          {
            type: RECEIVE_FILES_RESULTS,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_FILES_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
};

const getHistory = id => {
  return (dispatch, getState) => {
    let controlNumber = ValidateControlNumber(id, getState);
    if (controlNumber === 0) return;
    dispatch({
      [CALL_API]: {
        endpoint: ho.caseForm(controlNumber, "history"),
        method: HTTP_GET,
        types: [
          REQUEST_HISTORY_RESULTS,
          {
            type: RECEIVE_HISTORY_RESULTS,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_HISTORY_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getSketch = text => {
  return dispatch =>
    dispatch({
      [CALL_API]: {
        endpoint: ho.caseForm(text, "sketch"),
        method: HTTP_GET,
        types: [
          REQUEST_SKETCH_RESULTS,
          {
            type: RECEIVE_SKETCH_RESULTS,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_SKETCH_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
};

const getPublicPropertyRecord = text => {
  return dispatch =>
    dispatch({
      [CALL_API]: {
        endpoint: ho.caseForm(text, "publicpropertyrecord"),
        method: HTTP_GET,
        types: [
          REQUEST_PROP_RECORD_RESULTS,
          {
            type: RECEIVE_PROP_RECORD_RESULTS,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_PROP_RECORD_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
};

const getCaseAttributes = text => {
  return dispatch =>
    dispatch({
      [CALL_API]: {
        endpoint: ho.caseForm(text, "caseattributes"),
        method: HTTP_GET,
        types: [
          REQUEST_CASE_ATTR,
          {
            type: RECEIVE_CASE_ATTR,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_CASE_ATTR,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
};
const validateForms = (id, formId = null, callback = null) => {
  return (dispatch, getState) => {
    let controlNumber = ValidateControlNumber(id, getState);
    if (controlNumber === 0) return;
    dispatch({
      [CALL_API]: {
        endpoint: ho.validate(controlNumber, formId),
        method: HTTP_GET,
        types: [
          REQUEST_VALIDATE_FORMS,
          {
            type: RECEIVE_VALIDATE_FORMS,
            payload: (action, state, res) =>              
              res.json().then(data => {
                return { result: data, callback: callback };
              })
          },
          {
            type: ERROR_VALIDATE_FORMS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getPrivateNotes = text => {
  return dispatch =>
    dispatch({
      [CALL_API]: {
        endpoint: ho.caseForm(text, "privatenotes"),
        method: HTTP_GET,
        types: [
          REQUEST_PRIVATENOTES_RESULTS,
          {
            type: RECEIVE_PRIVATENOTES_RESULTS,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_PRIVATENOTES_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
};

function updatePrivateNotes(doc) {
  return (dispatch, getState) => {
    const controlNumber = getState().caseForms.caseHeader.caseInfo
      .controlNumber;
    dispatch({
      [CALL_API]: {
        endpoint: ho.caseForm(controlNumber, "privateNotes"),
        method: HTTP_POST,
        body: JSON.stringify(doc),
        types: [
          REQUEST_PRIVATENOTES_UPDATE,
          {
            type: RECEIVE_PRIVATENOTES_UPDATE,
            payload: () =>
              Promise.all([
                responseHandler.success(
                  "Private notes has been updated successfully",
                  dispatch
                )
              ]).then(() => doc)
          },
          {
            type: ERROR_PRIVATENOTES_UPDATE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
}

const formStatusChange = (formName, status, formId) => {
  return dispatch => {
    dispatch({
      type: FORM_STATUS_CHANGE,
      payload: { name: formName, status: status, id: formId }
    });
  };
};

function workflowMethod(workflow, method, comments) {
  return (dispatch, getState) => {
    const controlNumber = getState().caseForms.caseHeader.caseInfo
      .controlNumber;
    dispatch({
      [CALL_API]: {
        endpoint: ho.workflowMethod(
          controlNumber,
          workflow.toLowerCase(),
          method.toLowerCase()
        ),
        method: HTTP_POST,
        body: JSON.stringify(comments),
        types: [
          REQUEST_WORKFLOWMETHOD_RESULTS,
          {
            type: RECEIVE_WORKFLOWMETHOD_RESULTS,
            payload: (action, state, res) =>
              res.json().then(data => {
                let wfInProgress = getState().caseForms
                  .workflowActionInProgress;
                if (
                  wfInProgress != 0 &&
                  wfInProgress != data.appraisalWorkflowStatusId
                ) {
                  // workflow status changed already! synchronous call
                  responseHandler.success(data.message);
                }
                return data;
              })
          },
          {
            type: ERROR_WORKFLOWMETHOD_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
}

const setWorkflowMonitor = wf => {
  return dispatch =>
    // update workflow monitor state
    dispatch({
      type: UPDATE_WORKFLOW_MONITOR,
      payload: wf
    });
};

function getWorkflowStatus(id) {
  return (dispatch, getState) => {
    let controlNumber = ValidateControlNumber(id, getState);
    if (controlNumber === 0) return;
    dispatch({
      [CALL_API]: {
        endpoint: ho.getWorkflowStatus(controlNumber),
        method: HTTP_GET,
        types: [
          REQUEST_WORKFLOWSTATUS_RESULTS,
          {
            type: RECEIVE_WORKFLOWSTATUS_RESULTS,
            payload: (action, state, res) =>
              res.json().then(data => {
                let wfInProgress = getState().caseForms
                  .workflowActionInProgress;
                if (
                  wfInProgress != 0 &&
                  wfInProgress != data.appraisalWorkflowStatusId
                ) {
                  // workflow status change! asynch call
                  responseHandler.success(data.message);
                }
                return data;
              })
          },
          {
            type: ERROR_WORKFLOWSTATUS_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
}

const importMismo = (id, file, uploadFinishedCallback) => {
  const data = new FormData();
  data.append("file", file);

  return (dispatch, getState) => {
    const controlNumber = (id) ? id : getState().caseForms.caseHeader.caseInfo.controlNumber;
    dispatch({
      [CALL_API]: {
        endpoint: ho.importMismo(controlNumber),
        method: HTTP_POST,
        body: data,
        requestType: "upload", //this will get picked up in the middlewares/genericHeaders/index.js and it will delete our Content-Type that it usually sets so the browser can generate a proper Content-Type
        types: [
          REQUEST_IMPORT_MISMO,
          {
            type: RECEIVE_IMPORT_MISMO,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  setTimeout(() => {
                    uploadFinishedCallback(data);
                  }, 0);
                  return data;
                })
          },
          {
            type: ERROR_IMPORT_MISMO,
            payload: () => {
              let data = {
                error: true,
                errorMessages: ["Oops!  There was a problem importing the MISMO file."]
              };
              uploadFinishedCallback(data);
              //responseHandler.error(res, dispatch);
              return;
            }
          }
        ]
      }
    });
  };
};

const validationMessage = (text, type) => {
  let resp = [text];
  return dispatch => {
    dispatch({
      type: VALIDATE_RESPONSE,
      func: responseHandler.customToast(resp, type, dispatch)
    });
  };
};

const savePNXFormSuccess = () => {
  return dispatch => {
    dispatch({
      type: SUCCESS_PNX_SAVE,
      func: responseHandler.success("Save Successful", dispatch)
    });
  };
};

const backfillRCT = (controlNumber, PhoenixFormInstanceId, callBack = null) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: ho.backfillRCTForm(controlNumber, PhoenixFormInstanceId),
        method: HTTP_POST,
        types: [
          BACKFILL_RCT,
          {
            type: BACKFILL_RCT_SUCCESS,
            payload: () => {
              callBack && callBack();
            }
              
          },
          {
            type: BACKFILL_RCT_ERROR,
          }
        ]
      }

    });
  };
};


const savePNXFormFail = text => {
  return savePNXFormsMessage(text, "warning");
};

const savePNXFormsMessage = (text, type) => {
  let resp = [text];
  return dispatch => {
    dispatch(getHistory());
    dispatch(getValidationStatus());
    dispatch({
      type: ERROR_PNX_SAVE,
      func: responseHandler.customToast(resp, type, dispatch)
    });
  };
};

const getAppraisalQARejections = appraisalId => {
  return (dispatch, getState) => {
    const appraisalSurveyId = appraisalId
      ? appraisalId
      : getState().caseForms.caseHeader.caseInfo.appraisalSurveyInfo?.id;
    dispatch({
      [CALL_API]: {
        endpoint: ho.appraisalQaRejections(appraisalSurveyId),
        method: HTTP_GET,
        types: [
          REQUEST_APPRAISALQAREJECTIONS_RESULTS,
          {
            type: RECEIVE_APPRAISALQAREJECTIONS_RESULTS,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_APPRAISALQAREJECTIONS_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const resolveAppraisalQARejection = appraisalQaRejection => {
  return dispatch =>
    dispatch({
      [CALL_API]: {
        endpoint: ho.appraisalQaRejectionResolve(
          appraisalQaRejection.appraisalSurveyId,
          appraisalQaRejection.id
        ),
        method: HTTP_POST,
        body: JSON.stringify(appraisalQaRejection.responseNotes),
        types: [
          REQUEST_APPRAISALQAREJECTION_UPDATE,
          {
            type: RECEIVE_APPRAISALQAREJECTION_UPDATE,
            payload: (action, state, res) =>
              res.json().then(data => {
                dispatch(getValidationStatus());
                dispatch(
                  getAppraisalQARejections(
                    appraisalQaRejection.appraisalSurveyId
                  )
                );
                let message = "Your Response to QA has been saved and sent.";
                responseHandler.success(message, dispatch);
                return data;
              })
          },
          {
            type: ERROR_APPRAISALQAREJECTIONS_UPDATE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
};

const updateCaseHeader = (controlNumber, dto, callback = null) => {
  return dispatch =>
    dispatch({
      [CALL_API]: {
        endpoint: ho.updateCaseHeader(controlNumber),
        method: HTTP_PUT,
        body: JSON.stringify(dto),
        types: [
          REQUEST_UPDATE_CASEHEADER,
          {
            type: RECEIVE_UPDATE_CASEHEADER,
            payload: (action, state, res) => {
              if (callback) callback();
              return res.json().then(data => {
                return data;
              });
            }
          },
          {
            type: ERROR_UPDATE_CASEHEADER,
            payload: (action, state, res) => {
              if (callback) callback();
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
};

const getAppraisalFormData = (controlNumber) => {
  return dispatch =>
    dispatch({
      [CALL_API]: {
        endpoint: ho.getAppraisalFormData(controlNumber),
        method: HTTP_GET,
        types: [
          REQUEST_APPRAISAL_FORM_DATA,
          {
            type: RECEIVE_APPRAISAL_FORM_DATA,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_APPRAISAL_FORM_DATA,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
};

const setAppraisalFormData = (controlNumber, modifiedData, callback) => {
  return dispatch =>
    dispatch({
      [CALL_API]: {
        endpoint: ho.setAppraisalFormData(controlNumber),
        method: HTTP_POST,
        body: JSON.stringify(modifiedData),
        types: [
          REQUEST_SAVE_1004P_FORM_DATA,
          {
            type: RECEIVE_SAVE_1004P_FORM_DATA,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_SAVE_1004P_FORM_DATA,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }).then(callback);
};


const getPNXFormExportData = (controlNumber) => {
  return dispatch =>
    dispatch({
      [CALL_API]: {
        endpoint: ho.getPNXFormExportData(controlNumber),
        method: HTTP_GET,
        types: [
          REQUEST_PNX_FORM_EXPORT_DATA,
          {
            type: RECEIVE_PNX_FORM_EXPORT_DATA,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_PNX_FORM_EXPORT_DATA,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
};

const savePNXFormExportData = (controlNumber, availFormCode, modifiedData, callback) => {
  return dispatch =>
    dispatch({
      [CALL_API]: {
        endpoint: ho.savePNXFormExportData(controlNumber, availFormCode),
        method: HTTP_POST,
        body: JSON.stringify(modifiedData),
        types: [
          REQUEST_SAVE_PNX_FORM_EXPORT_DATA,
          {
            type: RECEIVE_SAVE_PNX_FORM_EXPORT_DATA,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_SAVE_PNX_FORM_EXPORT_DATA,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }).then(callback);
};

const submitCaseToQA = (controlNumber, callback = null, isCaseActionRequest = false) => {
  return dispatch =>
    dispatch({
      [CALL_API]: {
        endpoint: ho.submitCaseToQA(controlNumber, isCaseActionRequest),
        method: HTTP_POST,
        types: [
          REQUEST_SUBMIT_TO_QA,
          {
            type: RECEIVE_SUBMIT_TO_QA,
            payload: (action, state, res) => {
              res.json()
                .then(data => {
                  setTimeout(() => {
                    if (callback) callback(controlNumber);
                    responseHandler.success("Case Submitted to QA", dispatch);
                  }, 0);
                  return data;
                });
            }
          },
          {
            type: ERROR_SUBMIT_TO_QA,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
};

const cancelCase = (controlNumber, cancelComments, callback = null) => {
  return dispatch =>
    dispatch({
      [CALL_API]: {
        endpoint: ho.cancelCase(controlNumber),
        method: HTTP_POST,
        body: JSON.stringify({ cancelComments: cancelComments }),
        types: [
          REQUEST_CANCEL_CASE,
          {
            type: RECEIVE_CANCEL_CASE,
            payload: (action, state, res) => {
              res.json()
                .then(data => {
                  setTimeout(() => {
                    if (callback) callback(controlNumber);
                    responseHandler.success("Case Cancelled", dispatch);
                  }, 0);
                  return data;
                });
            }
          },
          {
            type: ERROR_CANCEL_CASE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
};

export const addAttachmentToCase = (controlNumber, file, fileId, uploadFinishedCallback) => {
  const data = new FormData();
  data.append("file", file);

  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: ho.uploadAttachment(controlNumber),
        method: HTTP_POST,
        body: data,
        requestType: "upload", //this will get picked up in the middlewares/genericHeaders/index.js and it will delete our Content-Type that it usually sets so the browser can generate a proper Content-Type
        types: [
          REQUEST_ADD_ATTACHMENT,
          {
            type: RECEIVE_ADD_ATTACHMENT,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  setTimeout(() => {
                    if (data.error) {
                      responseHandler.clientErrors(data.errorMessages, dispatch);
                    }
                    else {
                      uploadFinishedCallback(data);
                    }
                  }, 0);
                  return data;
                })
          },
          {
            type: ERROR_ADD_ATTACHMENT,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
              return;
            }
          }
        ]
      }
    })
  );
};

export const deleteAttachmentFromCase = (controlNumber, fileName, uploadFinishedCallback) => {
  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: ho.deleteAttachment(controlNumber, fileName),
        method: HTTP_DELETE,
        types: [
          REQUEST_DELETE_ATTACHMENT,
          {
            type: RECIEVE_DELETE_ATTACHMENT,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  setTimeout(() => {
                    if (data.error) {
                      responseHandler.clientErrors(data.errorMessages, dispatch);
                    }
                    else {
                      uploadFinishedCallback(data);
                    }
                  }, 0);
                  return data;
                })
          },
          {
            type: ERROR_DELETE_ATTACHMENT,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
              return;
            }
          }
        ]
      }
    })
  );
};

export const beginPhotosSortOrder = () => {
  return {
    type: BEGIN_PHOTOS_SORT_ORDER,
    payload: { value: true },
  };
};

export const setPhotosSortOrder = (sortedPhotos) => {
  return {
    type: SET_PHOTOS_SORT_ORDER,
    payload: sortedPhotos
  };
};

export const savePhotosSortOrder = (controlNumber, sortedPhotos) => {
  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: api.savePhotosSortOrder(controlNumber),
        method: HTTP_POST,
        body: JSON.stringify(sortedPhotos),
        types: [
          REQUEST_SAVE_PHOTOS_SORT_ORDER,
          {
            type: RECEIVE_SAVE_PHOTOS_SORT_ORDER,
            payload: () => { }
          },
          {
            type: ERROR_SAVE_PHOTOS_SORT_ORDER,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
              return;
            }
          }
        ]
      }
    })
  );
};

const getCaseHeaderV2Redux = controlNumber => WebApiReduxRequest(
  REQUEST_CASE_HEADER,
  RECEIVE_CASE_HEADER,
  ERROR_CASE_HEADER,
  HTTP_GET,
  ho.caseHeaderV2(controlNumber),
);

export const saveCompPhotoMetadata = payload => {
  return {
    type: SAVE_COMP_PHOTO_METADATA,
    payload: payload
  };
};

export const calculateRctMainStreet = (controlNumber, PhoenixFormInstanceId, calcTool, callback) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: ho.phoenixCalculateRctMainStreet(controlNumber, PhoenixFormInstanceId, calcTool),
        method: HTTP_POST,
        types: [
          REQUEST_PHOENIX_RCT_CALC,
          {
            type: RECEIVE_PHOENIX_RCT_CALC,
            payload: (action, state, res) =>
              res.json().then(() => {
                if (callback) {
                  callback();
                }
              })
          },
          {
            type: ERROR_PHOENIX_RCT_CALC,
          }
        ]
      }
    });
  };
};

export {
  getCaseForms,
  getCaseHeader,
  getFiles,
  getHistory,
  getSketch,
  getPrivateNotes,
  getWorkflowStatus,
  importMismo,
  updatePrivateNotes,
  savePNXFormSuccess,
  backfillRCT,
  savePNXFormFail,
  savePNXFormsMessage,
  formStatusChange,
  workflowMethod,
  setWorkflowMonitor,
  validateForms,
  validationMessage,
  getAppraisalQARejections,
  resolveAppraisalQARejection,
  getPublicPropertyRecord,
  getCaseAttributes,
  updateCaseHeader,
  getAppraisalFormData,
  setAppraisalFormData,
  getPNXFormExportData,
  savePNXFormExportData,
  submitCaseToQA,
  cancelCase,
  getCaseHeaderV2Redux,
};
